<template>
  <ul>
    <p class="title">《优秀站外收率》</p>
    <li
      v-for="(item, index) in zhanwaishoulv"
      :key="index"
      @click="gourl(item)"
    >
      <img src="@/assets/img/gif-icon/5.gif" alt="" />
      <span>{{ item.name }}</span>
      <span style="color: red">【{{ item.plan }}】</span>
      <span>{{ item.url }}</span>
    </li>
  </ul>
</template>

<script setup>
import { zhanwaishoulv } from "@/utils";
function gourl(e) {
  window.open("http://www." + e.url, "_blank");
}
</script>

<style lang="scss" scoped>
ul {
  border: 4px solid #3f9595;
  border-radius: 3px;
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    background-color: #42b5b59c;
    padding: 12px;
  }
  li {
    padding: 12px 0;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    background-color: #35d6b6;
    &:not(:last-child) {
      border-bottom: 1px solid #3ea33e;
    }
    img {
      width: 15px;
      height: 15px;
      float: left;
      margin-left: 16px;
    }
  }
}
</style>